export default __webpack_public_path__ + "static/media/vehicles.bd548858.jpg";